<template>
  <StepCard title="Protocolo e Status">
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field label="Número do Protocolo" :model-value="protocolNumber" readonly
          variant="outlined" density="compact"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field label="Status" :model-value="requestStatus" readonly variant="outlined"
          density="compact"></v-text-field>
      </v-col>
    </v-row>

    <div v-if="mensagemAviso" class="mt-2 pt-2 border-top">
       <p class="text-error font-weight-bold mb-1">
         Solicitação Indeferida!
       </p>
       <p class="text-caption text-grey-darken-1">
         {{ mensagemAviso }}
       </p>
    </div>
  </StepCard>
</template>

<script setup>
import StepCard from './StepCard.vue';

defineProps({
  protocolNumber: { type: String, required: true },
  requestStatus: { type: String, required: true },
  mensagemAviso: { type: String, default: '' }, 
});
</script>

<style scoped>
.border-top {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}
</style>